import React from 'react';
import { Menu, Dropdown } from 'semantic-ui-react';
import {
  arrayOf, shape, bool, string, func,
} from 'prop-types';

import convertDropdownOptions from './convertDropdownOptions';
import Search from './Search';

const Navigation = ({
  versions,
  loadingVersions,
  versionId,
  books,
  loadingBooks,
  bookId,
  setCurrent,
  chapters,
  loadingChapters,
  chapterId,
  handleSearchSubmit,
  displayingSearch,
  terms,
}) => (
  <Menu secondary stackable>
    <Dropdown
      aligned="center"
      item
      search
      placeholder="Versions..."
      options={convertDropdownOptions(versions)}
      value={versionId}
      onChange={(e, { value }) => setCurrent(e, value, 'version')}
      disabled={loadingVersions}
      loading={loadingVersions}
    />
    {!displayingSearch && (
      <Dropdown
        aligned="center"
        item
        search
        placeholder="Books..."
        options={convertDropdownOptions(books)}
        value={bookId}
        onChange={(e, { value }) => setCurrent(e, value, 'book')}
        disabled={loadingBooks}
        loading={loadingBooks}
      />
    )}
    {!displayingSearch && (
      <Dropdown
        aligned="center"
        item
        search
        placeholder="Chapters..."
        options={convertDropdownOptions(chapters)}
        value={chapterId}
        onChange={(e, { value }) => setCurrent(e, value, 'chapter')}
        disabled={loadingChapters}
        loading={loadingChapters}
      />
    )}
    <Menu.Item position="right">
      <Search handleSearchSubmit={handleSearchSubmit} terms={terms} />
    </Menu.Item>
  </Menu>
);

Navigation.propTypes = {
  versions: arrayOf(shape()).isRequired,
  loadingVersions: bool.isRequired,
  versionId: string.isRequired,
  books: arrayOf(shape()).isRequired,
  loadingBooks: bool.isRequired,
  bookId: string.isRequired,
  setCurrent: func.isRequired,
  chapters: arrayOf(shape()).isRequired,
  loadingChapters: bool.isRequired,
  chapterId: string.isRequired,
  handleSearchSubmit: func.isRequired,
  displayingSearch: bool.isRequired,
  terms: arrayOf(string).isRequired,
};

export default Navigation;
